import React from 'react';
import { List, Datagrid, TextField } from 'react-admin';

export const SettingsList = (props) => (
    <List title="Settings" {...props}>
        <Datagrid>
            <TextField source="name" />
            <TextField source="value" />
        </Datagrid>
    </List>
);


// WEBPACK FOOTER //
// ./src/pages/lists/Settings.js